<template>
   <!-- <nav class="navbar navbar-expand-lg navbar-dark mybg-dark rounded">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar1" aria-controls="navbar1"
      aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-md-center" id="navbar1">
      <ul class="navbar-nav">
        <li v-if="(auth=='loggedin' && userType=='admin')" class="nav-item" hidden>
          <router-link class="nav-link" to="/munkalap">Munkalap</router-link>
        </li>
        <li v-if="(auth=='' || auth==undefined) && (token==null || token==undefined)" class="nav-item">
          <router-link class="nav-link" to="/login">Bejelentkezés</router-link>
        </li>
        <li v-if="(auth=='loggedin' && userType=='admin')" class="nav-item">
          <router-link class="nav-link" to="/register">Felhasználók</router-link>
        </li>
        <li v-if="(auth=='loggedin' && userType=='admin' || userType=='user')" class="nav-item">
          <router-link class="nav-link" to="/keszlet">KÉSZLETLISTA</router-link>
        </li>
        <li v-if="(auth=='loggedin' && userType=='admin' || userType=='user')" class="nav-item">
          <router-link class="nav-link" to="/nyomdaikeszlet">Nyomdai munkák</router-link>
        </li>
        <li v-if="(auth=='loggedin' && userType=='admin')" class="nav-item">
          <router-link class="nav-link" to="/cikkek">CIKKEK</router-link>
        </li>
        <li v-if="(auth=='loggedin' && userType=='admin')" class="nav-item">
          <router-link class="nav-link" to="/status">Státuszok</router-link>
        </li>
        <li v-if="(auth=='loggedin' && userType=='admin')" class="nav-item">
          <router-link class="nav-link" to="/anyagtipusok">Anyag+kivitel</router-link>
        </li>
        <li v-if="(auth=='loggedin' && userType=='admin' || userType=='user')" class="nav-item">
          <router-link class="nav-link" to="/calculator">Új munkalap</router-link>
        </li>
        <li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Törzsadatok
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a class="dropdown-item" href="#">Action</a></li>
            <li><a class="dropdown-item" href="#">Another action</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item" href="#">Something else here</a></li>
          </ul>
        </li>

        </li>
      </ul>
    </div>
  </nav> -->

  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand to="/">Kezdőoldal</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-if="auth=='' && (token==null || token==undefined)" @click="$router.push('login')">Bejelentkezés</b-nav-item>
          <b-nav-item v-if="(auth=='loggedin' && userType=='admin' || userType=='user')" to="/ertekesites">ÉRTÉKESÍTÉS</b-nav-item>
          <b-nav-item v-if="(auth=='loggedin' && userType=='admin' || userType=='user')" to="/munkalap">MUNKALAP</b-nav-item>
          <b-nav-item v-if="(auth=='loggedin' && userType=='admin' || userType=='user')" to="/cikkek">KÉSZLETLISTA</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="(auth=='' || auth==undefined) && (token==null || token==undefined)" to="/login">Bejelentkezés</b-nav-item>
          <b-nav-item v-if="(auth=='loggedin' && userType=='admin' || userType=='user')" to="/keszlet">BEVÉTELEZÉS</b-nav-item>
          <b-nav-item-dropdown v-if="(auth=='loggedin' && userType=='admin')" text="Törzsadatok" right>
            <b-dropdown-item v-if="(auth=='loggedin' && userType=='admin')" to="/gyartok">GYÁRTÓK</b-dropdown-item>
            <b-dropdown-item v-if="(auth=='loggedin' && userType=='admin')" to="/raktarak">RAKTÁRAK</b-dropdown-item>
            <b-dropdown-item v-if="(auth=='loggedin' && userType=='admin')" to="/cikkcsoport">CIKKCSOPORTOK</b-dropdown-item>
            <b-dropdown-item v-if="(auth=='loggedin' && userType=='admin' || userType=='user')" to="/leltar">LELTÁR</b-dropdown-item>
            <b-dropdown-item v-if="(auth=='loggedin' && userType=='admin')" to="/register">FELHASZNÁLÓK</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown v-if="(auth=='loggedin' && userType=='admin' || userType=='user')" right>
            <template v-slot:button-content>
              <em>Felhasználó</em>
            </template>
            <b-dropdown-item v-if="(auth=='loggedin' && userType=='admin' || userType=='user')" to="/profile">Saját fiók</b-dropdown-item>
            <b-dropdown-item v-if="(auth=='loggedin' && userType=='admin' || userType=='user')" v-on:click="logout">Kilépés</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>

import EventBus from './EventBus'
import jwtDecode from 'jwt-decode'
import router from '../router'

export default {
  data: () => {
    return {
      auth: '',
      token: localStorage.usertoken,
      userType: ''
    }
  },

  methods: {
    logout () {
      localStorage.removeItem('usertoken')
      localStorage.removeItem('userType')
      localStorage.removeItem('auth')
      router.push({ name: 'Login' })
      window.location.reload()
    }

  },
  mounted () {
    EventBus.$on('logged-in', status => {
      this.auth = status
      this.userType = localStorage.userType
    })
    this.userType = localStorage.userType
    this.auth = localStorage.auth
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue